import React, { useState } from "react";
import { Container } from "react-bootstrap";
import CelltrionCare from "./popup/celltrionCare";
import Terms from "./popup/termsOfUse";
import ExitPrivacy from "./popup/exitPrivacy";
import { useLocation } from "react-router-dom";

// images
import WLogo from "../assets/img/logo-white.png";
import FooterLogo2 from "../assets/img/steqeyma-logo-footer.png";
import CelltrionLogo from "../assets/img/celltrion.png";

const Footer = () => {
  const [modalShow, setModalShow] = useState(false);
  const [exitPrivacy, setExitPrivacy] = useState(false);
  const [terms, setTerms] = useState(false);
  const location = useLocation();
  const isVegzelma = location?.pathname.includes("vegzelma");
  const isZymfentra = location?.pathname.includes("zymfentra");
  const isYuflyma = location?.pathname.includes("yuflyma");
  const isAdalimumab = location?.pathname.includes("adalimumab");
  const isSteqeyma = location?.pathname.includes("steqeyma");
  const prcBaseCode = "US-PSP-25-00007    06/25";
  const prcZymfentraCode = "US-ZYM-25-00046    04/25";
  const prcStobocloCode = "US-STB-25-00009    06/25";
  const prcOsenveltCode = "US-OSV-25-00009    06/25";
  const prcSteqymaCode = "US-CT-P43-24-00032    06/25";
  const isHomePage = location?.pathname === "/";
  const isPaySign = location.pathname.includes("steqeyma") || 
  location.pathname.includes("zymfentra") ||  
  location.pathname.includes("osenvelt") ||
  location.pathname.includes("stoboclo") || 
  location.pathname === "/";

  const prcCode = location.pathname.includes("stoboclo") ? prcStobocloCode : location.pathname.includes("osenvelt") ? prcOsenveltCode : location.pathname.includes("zymfentra") ? prcZymfentraCode : location.pathname.includes("steqeyma") ? prcSteqymaCode : prcBaseCode

  return (
    <>
      { isPaySign ? (
        <>
          <div className="desktop-footer">
            <CelltrionCare
              show={modalShow}
              onHide={() => setModalShow(false)}
              isVegzelma={isVegzelma}
              isZymfentra={isZymfentra}
              isYuflyma={isYuflyma}
              isAdalimumab={isAdalimumab}
              isSteqeyma={isSteqeyma}
            />

            <ExitPrivacy
              show={exitPrivacy}
              externalLink="https://www.celltrionconnect.com/patient-privacy-policy"
              onHide={() => setExitPrivacy(false)}
            />

            <Terms show={terms} onHide={() => setTerms(false)} />

            <footer className="footer">
              <Container fluid>
                <div className="footerT">
                  <img
                    style={{ height: "90px" }}
                    src={FooterLogo2}
                    alt="logo"
                  />
                  <img
                    style={{ width: "250px" }}
                    src={CelltrionLogo}
                    alt="logo"
                  />
                </div>
              </Container>
              <Container fluid>
                <div className="footerB">
                  <div style={{ lineHeight: 1.5, fontSize: "12px" }}>
                    Celltrion product and service names used on this website are
                    the respective trademarks of Celltrion Inc. and Celltrion
                    Holdings, Co., Ltd., used under license by Celltrion USA,
                    Inc.
                  </div>
                  <div className="footerB-info">
                    <div className="footerB-item">
                      <p
                        style={{
                          lineHeight: 1.5,
                          fontSize: "12px",
                          fontWeight: 600,
                        }}
                      >
                        © Celltrion USA, Inc. 2025 <span>•</span> 1 Evertrust
                        Plaza, Suite 1207, Jersey City, NJ 07302-3087{" "}
                        <span>•</span> Contact us at 1-877-81CONNC
                        (1-877-812-6662)
                      </p>
                      <p
                        style={{
                          lineHeight: 1.5,
                          fontSize: "14px",
                          marginTop: "5px",
                        }}
                      >
                        {!isHomePage && (
                          <>
                           <a
                              style={{
                                textDecoration: "underline",
                              }}
                              href="https://www.celltrionconnect.com/terms-of-use/"
                              target="_blank"
                            >
                              Terms and Conditions
                            </a>
                          </>
                        )}
                        {isHomePage && (
                          <>
                            <a
                              style={{
                                textDecoration: "underline",
                              }}
                              href="https://www.celltrionconnect.com/terms-of-use/"
                              target="_blank"
                            >
                              Terms and Conditions
                            </a>
                          </>
                        )}
                        <span>•</span>{" "}
                        <a
                          style={{
                            textDecoration: "underline",
                          }}
                          href="javascript:void(0)"
                          onClick={() => setExitPrivacy(true)}
                        >
                          Privacy Policy
                        </a>
                      </p>
                    </div>
                    <div
                      className="footerB-item"
                      style={{
                        fontWeight: 400,
                        fontSize: "12px",
                        marginTop: "5px",
                      }}
                    >
                      {prcCode}
                    </div>
                  </div>
                </div>
              </Container>
            </footer>
          </div>
          <div className="mobile-footer">
            <CelltrionCare
              show={modalShow}
              onHide={() => setModalShow(false)}
              isVegzelma={isVegzelma}
              isZymfentra={isZymfentra}
              isYuflyma={isYuflyma}
              isAdalimumab={isAdalimumab}
              isSteqeyma={isSteqeyma}
            />

            <ExitPrivacy
              show={exitPrivacy}
              externalLink="https://www.celltrionconnect.com/patient-privacy-policy"
              onHide={() => setExitPrivacy(false)}
            />
            <Terms show={terms} onHide={() => setTerms(false)} />
            <footer className="footer">
              <Container fluid>
                <div className="footerT">
                  <img
                    className="mobile-footer-logo"
                    style={{ height: "90px" }}
                    src={FooterLogo2}
                    alt="logo"
                  />
                </div>
              </Container>
              <Container fluid>
                <div className="footerB">
                  <div style={{ lineHeight: 1.5, fontSize: "12px" }}>
                    Celltrion product and service names used on this website are
                    the respective trademarks of Celltrion Inc. and Celltrion
                    Holdings, Co., Ltd., used under license by Celltrion USA,
                    Inc.
                  </div>
                  <div className="footerT">
                    <img
                      className="mobile-footer-logo"
                      style={{ width: "250px" }}
                      src={CelltrionLogo}
                      alt="logo"
                    />
                  </div>
                  <div className="footerB-info">
                    <div className="footerB-item">
                      <p
                        style={{
                          lineHeight: 1.5,
                          fontSize: "10px",
                          fontWeight: 600,
                        }}
                      >
                        © Celltrion USA, Inc. 2025 <span>•</span> 1 Evertrust
                        Plaza, Suite 1207, Jersey City, NJ 07302-3087{" "}
                        <span>•</span> Contact us at 1-877-81CONNC
                        (1-877-812-6662){" "}
                        <a
                          style={{
                            textDecoration: "underline",
                          }}
                          href="/"
                        >
                          Terms and Condition
                        </a>{" "}
                        <span>•</span>{" "}
                        <a
                          style={{
                            textDecoration: "underline",
                          }}
                          href="/"
                        >
                          Privacy Policy
                        </a>
                      </p>
                    </div>
                    <div
                      className="footerB-item"
                      style={{
                        fontWeight: 400,
                        fontSize: "12px",
                        marginTop: "5px",
                      }}
                    >
                    </div>
                    <div style={{
                        fontWeight: 400,
                        fontSize: "12px",
                        marginTop: "5px",
                      }}>{prcCode}</div>
                  </div>
                </div>
              </Container>
            </footer>
          </div>
        </>
      ) : (
        <>
          <CelltrionCare
            show={modalShow}
            onHide={() => setModalShow(false)}
            isVegzelma={isVegzelma}
            isZymfentra={isZymfentra}
            isYuflyma={isYuflyma}
            isAdalimumab={isAdalimumab}
            isSteqeyma={isSteqeyma}
          />

          <ExitPrivacy
            show={exitPrivacy}
            externalLink="https://www.celltrionconnect.com/patient-privacy-policy"
            onHide={() => setExitPrivacy(false)}
          />

          <Terms show={terms} onHide={() => setTerms(false)} />

          <footer className="footer">
            <Container>
              <div className="footerT">
                <img src={WLogo} alt="logo" />
                <img src={CelltrionLogo} alt="logo" />
              </div>
            </Container>
            <Container>
              <div className="footerB">
                <div style={{ lineHeight: 1.5 }}>
                  Celltrion product and service names used on this website are
                  the respective trademarks of{" "}
                </div>
                <div style={{ lineHeight: 1.5 }}>
                  Celltrion Inc. and Celltrion Holdings, Co., Ltd., used under
                  license by Celltrion USA, Inc.
                </div>
                <div className="footerB-info">
                  <div className="footerB-item">
                    <p>
                      <strong>&copy;Celltrion USA, Inc.</strong> • 1 Evertrust
                      Plaza, Suite 1207, Jersey City, NJ 07302-3087
                    </p>
                  </div>
                  <div className="footerB-item">
                    <a href="tel:8778126662">
                      <strong>Contact us at 877-81CONNC (877-812-6662)</strong>
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                      href="javascript:void(0)"
                      onClick={() => setExitPrivacy(true)}
                    >
                      Privacy Policy
                    </a>{" "}
                    •{" "}
                    {!isHomePage && (
                      <>
                        <a
                          href="javascript:void(0)"
                          onClick={() => setModalShow(true)}
                        >
                          Terms and Conditions
                        </a>
                      </>
                    )}
                    {isHomePage && (
                      <>
                        <a
                          href="https://www.celltrionconnect.com/terms-of-use/"
                          target="_blank"
                        >
                          Terms and Conditions
                        </a>
                      </>
                    )}
                    &nbsp;&nbsp;&nbsp;&nbsp;{prcCode}
                  </div>
                </div>
              </div>
            </Container>
          </footer>
        </>
      )}
    </>
  );
};

export default Footer;
